import React from "react";
import { Card, Table } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { FleetTableRow } from "pages/dashboard/main/widgets/fleet_table/FleetTableRow";
import { useApp } from "common/context";

export const FleetTable = () => {

    const { fleets } = useApp();

    return (
        <>
            <h3 className="text-secondary">
                <FormattedMessage
                    id="label.live_fleet_metrics"
                    defaultMessage="Live Fleet Metrics"
                />
            </h3>
            <Card>
                <Card.Body>
                    <Table striped responsive>
                        <thead>
                            <tr>
                                <th>
                                    <FormattedMessage
                                        id="label.name"
                                        defaultMessage="Name"
                                />
                                </th>
                                <th>
                                    <FormattedMessage
                                        id="label.state"
                                        defaultMessage="State"
                                />
                                </th>
                                <th>
                                    <FormattedMessage
                                        id="label.sessions"
                                        defaultMessage="Sessions"
                                />
                                </th>
                                <th>
                                    <FormattedMessage
                                        id="label.queue"
                                        defaultMessage="Queue"
                                    />
                                </th>
                                <th style={{ minWidth: 150 }}>
                                    <FormattedMessage
                                        id="label.pressure"
                                        defaultMessage="Pressure"
                                    />
                                </th>
                                <th className="text-center">
                                    <FormattedMessage
                                        id="label.sessions"
                                        defaultMessage="Sessions"
                                />
                                    <br/>
                                    <small className="text-secondary">
                                        <FormattedMessage
                                            id="label.past_24hr"
                                            defaultMessage="(past 24hr)"
                                    />
                                    </small>
                                </th>
                                <th className="text-center">
                                    <FormattedMessage
                                        id="label.sessions"
                                        defaultMessage="Sessions"
                                />
                                    <br/>
                                    <small className="text-secondary">
                                        <FormattedMessage
                                            id="label.today"
                                            defaultMessage="(today)"
                                    />
                                    </small>
                                </th>
                                <th className="text-center">
                                    <FormattedMessage
                                        id="label.minutes"
                                        defaultMessage="Minutes"
                                    />
                                    <br/>
                                    <small className="text-secondary">
                                        <FormattedMessage
                                            id="label.today"
                                            defaultMessage="(today)"
                                    />
                                    </small>
                                </th>
                                <th className="text-center d-none d-md-table-cell">
                                    <FormattedMessage
                                        id="label.avg_queue_time"
                                        defaultMessage="Avg. Queue Time"
                                    />
                                    <br/>
                                    <small className="text-secondary">
                                        <FormattedMessage
                                            id="label.last_10_mins"
                                            defaultMessage="(last 10 mins)"
                                        />
                                    </small>
                                </th>
                                <th>

                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {fleets.map((fleet, key) => (
                                <FleetTableRow
                                    key={key}
                                    fleet={fleet.fleet_stat}
                                    title={fleet.name}
                                />
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

        </>
    );
};